import { defineMessages } from 'react-intl';

export default defineMessages({
    reasonForRewrite: {
        id: 'rewrite.common.views.ml-effective-date.Reason for Rewrite',
        defaultMessage: 'Reason for Rewrite'
    },
    offeringType: {
        id: 'rewrite.common.views.ml-effective-date.Offering Type',
        defaultMessage: 'Offering Type'
    },
    effectiveDateForRewrite: {
        id: 'rewrite.common.views.ml-effective-date.Effective Date for Rewrite',
        defaultMessage: 'Effective Date for Rewrite'
    },
    expirationDateForRewrite: {
        id: 'rewrite.common.views.ml-effective-date.rewrite.common.views.ml-effective-date.Expiration Date for Rewrite',
        defaultMessage: 'Expiration Date for Rewrite'
    },
    nextDescription: {
        id: 'rewrite.common.views.ml-effective-date.Well confirm coverages',
        defaultMessage: 'We\'ll confirm <strong>coverages on the rewrite policy</strong> next'
    },
    errorMessageGCS: {
        id: 'rewrite.common.views.ml-effective-date.This rewrite option will require us to assist you. Please contact us for assistance.',
        defaultMessage: 'This rewrite option will require us to assist you. Please contact us for assistance.'
    },
    errorMessage: {
        id: 'rewrite.common.views.ml-effective-date.This rewrite option will require us to assist you. To complete, please chat or call the Agency Resource Center at 1-866-539-1315 for assistance.',
        defaultMessage: 'This rewrite option will require us to assist you. To complete, please chat or call the Agency Resource Center at 1-866-539-1315 for assistance.'
    },
    save: {
        id: 'rewrite.common.config.Quoting rewrite',
        defaultMessage: 'Quoting rewrite'
    },
    saveErrorTitle: {
        id: 'rewrite.common.config.Unable to quote rewrite',
        defaultMessage: 'Unable to quote rewrite'
    },
    saveErrorMessage: {
        id: 'rewrite.common.config.An error occurred while quoting the rewrite',
        defaultMessage: 'An error occurred while quoting the rewrite'
    },
    transactionRequestedByAgent: {
        id: 'rewrite.common.views.transactionRequestedByAgent_Ext',
        defaultMessage: 'Is this transaction requested by an agent?'
    }
});